<template>  
    <div>
        
        <div class="row" v-if="skeleton">
            <div  class="mb-2 col-md-12 placeholder-glow">
                <div class="placeholder mr-2 mb-2 rounded" style="height: 20px; width: 50px;"></div>
            </div>
            <div  class="pt-2 col-md-12 placeholder-glow">
                <div class="placeholder rounded" style="height: 25px; width: 100%;"></div>
                <div class="d-flex justify-content-between mt-3 placeholder-glow">
                    <div class="placeholder rounded" style="height: 35px; width: 30%;"></div>
                    <div class="placeholder rounded" style="height: 35px; width: 30%;"></div>
                </div>

            </div>
        </div>
        <client-only>
            <transition name="custom-transition" mode="out-in" >
                <div class="row" key="1" v-show="!skeleton&&options">
                    
                    <div v-if="filter && options?.max" class="col-12 d-flex align-items-center mt-1 mb-2">
                        <span class="filter_title me-1 mb-1">{{ filter.label }}</span>
                        <div class="ques_pop">
                            <ModalSlideModal v-if="filter.name != 'price'" :item="filter.label" />
                            <!-- 
                                <ModalLooseLWRatio v-if="filter.name === 'ratio'" />
                            <Table v-if="filter.name === 'table'" />
                            <Depth v-if="filter.name === 'depth'" /> -->
                        </div>
                    </div>
                    <div v-if="filter && options?.max" class="col-12 pt-2">
                        <div class="row number_row">
                            <div class="col-12 mb-3 mt-1 pe-4">
                                <div ref="slider"></div>
                            </div>
                           
                            <div class="col-6 col-md-6">
                                <div class="input-group">
                                    <input  
                                        class="form-control input_min" 

                                        :value="formatFromValue" 
                                        @focus="unsetNotation('from')"
                                        @focusout="handleInputBlur($event)"
                                        @blur="setNotation('from')"
                                        @keyup.enter="handleInputBlur($event)"
                                        @change="updateSlider('from', $event.target.value)"
                                        :min="options.min"
                                        :max="options.max"
                                        placeholder="" 
                                        name="price_from"
                                    />
                                </div>
                            </div>
                            <div class="col-6 col-md-6">
                                <div class="input-group justify-content-end">
                                    <input 
                                        class="form-control input_max" 
                                        :value="formatToValue" 
                                        @focus="unsetNotation('to')"
                                        @focusout="handleInputBlur($event)"
                                        @blur="setNotation('to')"
                                        @keyup.enter="handleInputBlur($event)"
                                        @change="updateSlider('to', $event.target.value)"
                                        :min="options.min"
                                        :max="options.max"
                                        placeholder="" 
                                        name="price_to" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </client-only>
        
    </div>


</template>


<script setup>
    import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount, inject } from 'vue'
    import noUiSlider from 'nouislider'
    
    
    import {cyolistStore}  from '@/stores/cyolist/cyolist';

    const { $formatPrice, $country } = useNuxtApp()

    const store = cyolistStore();
    const props = defineProps(['name'])
    const moduleSubType = inject('moduleSubType')

    const skeleton = ref(true)
    const debounce = ref(null)

    const counter = ref(0)
    const notation = ref({ from: true, to: true })

    const slider = ref(null)

    const filter = computed(() => store.getSettingFilter(moduleSubType, props.name))
    const options = computed(() => store.getSettingFilterOptions(moduleSubType, props.name))

    const unsetNotation = (endpoint) => {

        notation.value[endpoint] = false
    }

    const setNotation = (endpoint) => {
        notation.value[endpoint] = true
    }



    const formatFromValue = computed(() => {
        if (!filter.value.config.format || !notation.value.from) {
            return options.value.from
        }

        if (filter.value.name === 'price') {
            return $formatPrice(options.value.from)
        }

        return filter.value.config.format.position == 'prepend'
            ? filter.value.config.format.notation + options.value.from
            : options.value.from + filter.value.config.format.notation
    })

    const formatToValue = computed(() => {
        if (!filter.value.config.format || !notation.value.to) {
            return options.value.to
        }

        if (filter.value.name === 'price') {
            return $formatPrice(options.value.to)
        }

        return filter.value.config.format.position == 'prepend'
            ? filter.value.config.format.notation + options.value.to
            : options.value.to + filter.value.config.format.notation
    })

    watch(options, (newVal) => {
        if (newVal) {
            nextTick(() => {
                if (slider.value?.noUiSlider && newVal.max) {
                    slider.value.noUiSlider.set([parseFloat(newVal.from), parseFloat(newVal.to)])
                }else if( sliderEligibility() ){

                    initializeSlider()
                    skeleton.value = false
                }
            })
        }
    })

    const sliderEligibility = () => !slider.value?.noUiSlider && options.value?.max && slider.value

    const initializeSlider = () => {

        noUiSlider.create(slider.value, {
            start: [parseFloat(options.value.from), parseFloat(options.value.to)],
            connect: true,
            decimals: 0,
            step: filter.value.config.step,
            range: {
                'min': parseFloat(options.value.min),
                'max': parseFloat(options.value.max),
            }
        })

        slider.value.noUiSlider.on('update', (values) => {
            options.value.from = parseFloat(values[0])
            options.value.to = parseFloat(values[1])
        })

        slider.value.noUiSlider.on('change', (values) => {
            const object = { reset: false, type: moduleSubType, filter: filter.value, option: { value: false } }
            store.toggleSettingFilter( object)
        })
    }

    const handleInputBlur = (event) => {
        // console.log('options.value.from', options.value.from)
        // const object = { reset: false, type: moduleSubType, filter: filter.value, option: { value: options.value.from } }
        // store.toggleSettingFilter( object)
        event.target.blur()
    }

    const updateSlider = (range, value) => {

        slider.value.noUiSlider.set( range == 'from' ?  [ value, null ] : [ null, value ] );

        const object = { reset: false, type: moduleSubType, filter: filter.value, option: { value: options.value.from } }
        store.toggleSettingFilter( object)
        clearTimeout(debounce.value)
    }

    onMounted( async () => {

        await nextTick();

        if (sliderEligibility()) {
            initializeSlider()
            skeleton.value = false
        }
    })

    onBeforeUnmount(() => {
        if (slider.value?.noUiSlider) {
            slider.value.noUiSlider.destroy()
        }
    })
</script>



<style scoped>
    .placeholder{
        background-color: rgba(0, 0, 0, 0.3);
    }

    .filter_title {
        color: #333333;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        line-height: normal;
    }
    .input-group input {
        border: 1px solid #c6cbd4;
        border-radius: 4px;
        height: 30px;
        max-width: 120px;
        /* font-size: 14px; */
        font-size: 16px;

        text-align: center;
        padding: 5px;
        outline: none;
    }
    .ques_pop {
        margin-top: -2px;
        height: 18px;
    }


    @media(max-width: 767px){
        .row.number_row {
            padding: 0 7px;
        }
    }
</style>

